"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _createReducer = _interopRequireDefault(require("../helpers/createReducer.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var initialState = exports.initialState = (0, _immutable.fromJS)({
  loading: 'initialized',
  // we assume that we are going to load the session first with sessionCheck()
  is_logged_in: false,
  logged_in_at: null,
  current_user_id: 0,
  selected_question_bank_id: 0,
  current_sign_in_at: null,
  cme_invalid: true,
  can_see_correct_answers: false,
  selected_organization_id: 0,
  questions_on_templates_bank_id: 0,
  questions_on_templates: [],
  isLti: false
});
var reducers = {};
var checkLti = function checkLti(state, payload) {
  var includes = payload.included;
  var assignment = includes.find(function (i) {
    return i.type === 'assignment';
  });
  if (assignment) return state.set('isLti', assignment.attributes.is_lti);
  return state;
};
reducers[_constants.SESSION_FETCHING] = function sessionFetching(state) {
  return state.set('loading', true);
};
reducers[_constants.QUIZ_FETCHED_PERFORMANCE] = checkLti;
reducers[_constants.QUIZ_FETCHED_TAKE] = checkLti;
reducers[_constants.QUIZ_SUBMITTED] = checkLti;
reducers[_constants.SESSION_FETCHED] = function sessionFetched(state, payload) {
  var user = payload.data;
  return initialState.set('loading', false).set('isIframe', payload.isIframe).set('is_logged_in', true).set('logged_in_at', Date.now()).set('current_user_id', parseInt(user.id)).set('selected_question_bank_id', parseInt(user.relationships.last_selected_question_bank.data.id)).set('selected_organization_id', payload.selectedOrganizationId || 0).set('current_sign_in_at', new Date(user.attributes.current_sign_in_at).getTime());
};
reducers[_constants.SESSION_RESET] = function sessionReset() {
  return initialState.set('loading', false);
};
reducers[_constants.SESSION_RESET_OFFLINE] = function sessionResetOffline(state) {
  return state.set('loading', false);
};
reducers[_constants.SESSION_SET_SEARCH_ID] = function (state, _ref) {
  var searchId = _ref.searchId;
  return state.set('search_id', searchId);
};
reducers[_constants.SESSION_SET_CAN_SEE_CORRECT_ANSWERS] = function (state, payload) {
  return state.set('can_see_correct_answers', payload.enabled);
};
reducers[_constants.ORGANIZATION_SELECTED] = function (state, payload) {
  return state.set('selected_organization_id', payload.organizationId);
};

// Non-Session Action Reducers

reducers[_constants.QUESTION_BANK_SELECTED] = function questionBankSelected(state, payload) {
  return state.merge({
    selected_question_bank_id: parseInt(payload.data.id),
    search_id: null
  });
};
reducers[_constants.RESPONSE_SYNCED] = function responseSynced(state) {
  return state.set('cme_invalid', true);
};
reducers[_constants.CME_TRACKER_FETCHED] = function cmeFetched(state) {
  return state.set('cme_invalid', false);
};
reducers[_constants.QUESTIONS_ON_TEMPLATE_FETCHED] = function questionBankSelected(state, payload) {
  return state.merge({
    questions_on_templates: payload.questions_on_templates,
    questions_on_templates_bank_id: payload.bank_id
  });
};
reducers[_constants.EXAM_TEMPLATE_UPDATED] = function questionBankSelected(state, payload) {
  if (state.get('questions_on_templates_bank_id') !== parseInt(payload.data.relationships.question_bank.data.id)) return state;
  return state.merge({
    questions_on_templates_bank_id: 0
  });
};
var _default = exports.default = (0, _createReducer.default)(reducers, initialState);